export const JOB_STATUSES = [
  'Applied',
  'Screening',
  'Interview',
  'Assessment',
  'Offer',
  'Accepted',
  'Rejected',
  'Withdrawn',
  'Ghosted'
];

export const JOB_STAGES = [
  '',
  'Applied',
  'HR Screening',
  'HR Interview',
  'Technical Exam',
  'Technical Interview',
  'Final Interview',
  'Offer Negotiation',
  'Closed'
];

export const WORK_SETUPS = ['Onsite', 'Hybrid', 'Remote', 'Not specified'];

export const JOB_SOURCES = [
  'LinkedIn',
  'Jobstreet',
  'Indeed',
  'Kalibrr',
  'Glassdoor',
  'Company Website',
  'Referral',
  'Recruiter',
  'Other'
];

// Light-theme status colors
export const STATUS_COLORS = {
  Applied:    { bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE', pin: '#DBEAFE' },
  Screening:  { bg: '#FFFBEB', text: '#B45309', border: '#FDE68A', pin: '#FEF3C7' },
  Interview:  { bg: '#EEF2FF', text: '#4338CA', border: '#C7D2FE', pin: '#E0E7FF' },
  Assessment: { bg: '#F0FAFE', text: '#0E7490', border: '#A5F3FC', pin: '#CFFAFE' },
  Offer:      { bg: '#F0FDF4', text: '#15803D', border: '#BBF7D0', pin: '#DCFCE7' },
  Accepted:   { bg: '#ECFDF5', text: '#065F46', border: '#6EE7B7', pin: '#D1FAE5' },
  Rejected:   { bg: '#FFF1F2', text: '#BE123C', border: '#FECDD3', pin: '#FFE4E6' },
  Withdrawn:  { bg: '#FAF5FF', text: '#6D28D9', border: '#DDD6FE', pin: '#EDE9FE' },
  Ghosted:    { bg: '#F9FAFB', text: '#4B5563', border: '#D1D5DB', pin: '#F3F4F6' },
};

export const TASK_TYPES = [
  'HR Screening Call',
  'HR Interview',
  'Technical Interview',
  'Technical Exam / Assessment',
  'Final Interview',
  'Offer Discussion',
  'Background Check',
  'Follow-up Call',
  'Networking Call',
  'Other',
];
